// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"678":"a353d0f9c0a995159175","731":"50a6dabafe7d779dd9de","843":"4d22e4d87d98fa226c97","883":"24c1fe570e8a4523eb25"}[chunkId] + ".js";
};